import { useCallback } from "react";
import { useComposedSortPersist } from "./compose/useComposedSortPersist.js";
import { useFolderTree } from "../contexts/folderTree.js";
function useFolderTreeSort() {
    const { onSort } = useFolderTree();
    const runSortPersist = useComposedSortPersist();
    return useCallback(async (args)=>{
        if (!onSort) {
            return undefined;
        }
        return runSortPersist(async ()=>onSort(args));
    }, [
        onSort,
        runSortPersist
    ]);
}
export { useFolderTreeSort };
